import { initStore } from '../../../common';
import { actions } from './actions';

export const gameCategoriesStore = (): void => {
	const initialState = {
		slice: 'CASINO_GAME_CATEGORIES',
		gameCategories: [],
		gamesLoading: false,
		savingData: false,
		pagesTotal: 1,
		currentPage: 1,
		rows: [],
		bulkRows: [],
		columns: [],
		perPage: '10',
		// active: [
		// 	{ value: '0', label: 'Disabled', isChecked: false },
		// 	{ value: '1', label: 'Enabled', isChecked: false },
		// ],
		filtering: false,
		globalErrors: [],
		selectedGameCategory: null,
		gameCategoryForm: {
			game_name: '',
			game_id: '',
		},
		formErrors: null,
		globalSuccess: '',
	};

	initStore(actions, initialState);
};
